<template>
  <div class="col">

    <div class="row mt-5 ">
      <div class="col">
        <h5>{{ orderProduct.productName }} ({{ orderProduct.productNumber }})</h5>
        <p>{{ orderProduct.amountUnloaded }} / {{ orderProduct.amount }}</p>
      </div>
      <div class="col">
        <button class='btn btn-primary float-right' @click="goBack()"
        > {{ $t('button.back') }}
        </button>
      </div>
    </div>

    <div class="row mt-5 ">
      <div class="col">
        <label
            for="description_pickable1">{{ $t('shopfloor.teamlead.manual.orderProduct.amountUnloadPickableTitle') }} </label>
        <p id="description_pickable1" v-html="$t('shopfloor.teamlead.manual.orderProduct.unloadAmountDescription')"/>
      </div>
      <div class="col">
        <label for="amountPickable">{{ $t('shopfloor.teamlead.manual.orderProduct.amountUnloadPickableTitle') }}</label>
        <div class="input-group input-group-lg">
          <div class="input-group-prepend">
            <button @click="orderProduct.amount--" :disabled="orderProduct.amount <=0" class="btn btn-default"
                    id="inputGroup-sizing-lg111">
              <i class="fas fa-minus"/>
            </button>
          </div>
          <input type="text" id="amountPickable1" class="form-control" v-model="orderProduct.amount"
                 aria-label="Large" aria-describedby="inputGroup-sizing-sm">
          <div class="input-group-append">
            <button @click="orderProduct.amount++" class="btn btn-default" id="inputGroup-sizing-lg121">
              <i class="fas fa-plus"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5 ">
      <div class="col">
        <label for="description_pickable">{{ $t('shopfloor.teamlead.manual.orderProduct.unloadTitle') }} </label>
        <p id="description_pickable" v-html="$t('shopfloor.teamlead.manual.orderProduct.unloadDescription')"/>
      </div>
      <div class="col">
        <label for="location">{{ $t('shopfloor.teamlead.manual.orderProduct.locationForUnload') }}</label>
        <select v-model="unloadLocation" id="location" class="form-control">
          <option :value="null" selected disabled> {{ $t('shopfloor.teamlead.unloading.location') }}</option>
          <option :key="location.id" :value="location.id" v-for="(location,idx) in getLocationsSortedByName" :selected="idx==0">
            {{ location.name }}
          </option>
        </select>
      </div>
      <div class="col">
        <label for="amountPickable">{{ $t('shopfloor.teamlead.manual.orderProduct.amountUnloaded') }}</label>
        <div class="input-group input-group-lg" v-if="unloadLocation">
          <div class="input-group-prepend">
            <button @click="manualUnload--"
                    :disabled="manualUnload <= 0" class="btn btn-default"
                    id="inputGroup-sizing-lg11">
              <i class="fas fa-minus"/>
            </button>
          </div>
          <input type="text" id="amountPickable" class="form-control" v-model.number="manualUnload"
                 aria-label="Large" aria-describedby="inputGroup-sizing-sm">
          <div class="input-group-append">
            <button
                @click="manualUnload++"
                :disabled="orderProduct.amount <= manualUnload"
                class="btn btn-default" id="inputGroup-sizing-lg12">
              <i class="fas fa-plus"/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5 ">
      <div class="col">
        <button class="btn btn-primary" @click="save()">Save</button>
      </div>

    </div>


  </div>

</template>


<script>
import {mapGetters} from 'vuex';
import {swalModals} from './../../mixins/swalModals';


export default {
  props: ['order', 'product'],
  mixins: [swalModals],
  components: {
    // orderDestination
  },
  data() {
    return {
      trackAmount: true,
      manualUnload: 0,
      unloadLocation: null,
      orderProduct: {},
      hasLocation: false
    };
  },
  firestore() {
    return {
      orderProduct: this.$FB.collection('incoming-order-products').doc(this.product.id)
    };
  },
  computed: {
    ...mapGetters('locations', ['getLocationsSortedByName']),
    ...mapGetters('users', [
      'getMeBasic'
    ])
  },
  methods: {
    async save() {
      this.$FB.collection('incoming-order-products').doc(this.product.id).update({
        manualAdjustment: true,
        manualAdjustmentBy: this.getMeBasic.userName,
        // barcodeUnreadable: this.orderProduct.barcodeUnreadable ?  this.orderProduct.barcodeUnreadable : false ,
        amount: this.orderProduct.amount,
        // amountUnloaded: (this.orderProduct.amountUnloaded + parseInt(this.manualUnload)),

      }).then(async () => {

        this.hasChanges = false;
        let tempIncomingObject = {
          barcode: this.orderProduct.productNumber,
          companyId: this.getMeBasic.companyId,
          endTime: new Date(),
          locationId: this.unloadLocation,
          startTime: new Date(),
          product: this.orderProduct,
          userId: this.getMeBasic.userId,
          userName: this.getMeBasic.userName
        };
        for (var i = 0; i < this.manualUnload; i++) {
          await this.$FB.collection('incoming-products').add(tempIncomingObject);
        }
        this.manualUnload = 0;
        return this.$swal({
          customClass: {
            header: 'align-items-center'
          },
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 5000,
          type: 'success',
          title: this.$root.$t('shopfloor.teamlead.loading.saveSuccess')
        });
      });
    },
    goBack() {
      if (this.hasChanges) {
        return this.swalUnsavedChanges().then(res => {
          if (res.value == true) {
            this.$router.go(-1)
            //this.$router.push({name: 'teamlead-unloading-sender-overview'});
          }
        });
      } else {
        this.$router.go(-1)

        //this.$router.push({name: 'teamlead-unloading-sender-overview'});
      }
    }
  },
  watch: {
    getLocationsSortedByName(newV, oldV) {
      if (oldV) {
        if (newV[0])
          this.unloadLocation = newV[0].id;
      }
    },
    orderProduct(newV, oldV) {

      if (!newV.amountUnloaded) {
        this.orderProduct.amountUnloaded = 0;
      }
      if (newV.name) {
        this.hasLocation = true;
      }
    },
    'orderProduct.amountUnloaded': function (newV, oldv) {
      if (oldv !== undefined)
        this.hasChanges = true;
    }

  },
  async beforeRouteLeave(to, from, next) {
    // await this.$store.dispatch('resetStoreModules', ['locations']);
    next();
  },
  created() {
    this.$store.dispatch('initDataForPage', []);
  }
};
</script>

<style lang="scss" scoped>
.fully-picked {
  color: green;
}

.not-fully-picked {
  color: red;
}
</style>
